

























































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import StoreSuketTindakanHd from "@/store/modules/SuketTindakanHd";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf
  }
})
export default class SuketTindakanHdTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.TindakanHd);
  suketStore = StoreSuketTindakanHd;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;

  saving = false;
  loadedRatio = 0;

  frekuensiOptions = [
    { text: "1× / minggu", value: "1x" },
    { text: "2× / minggu", value: "2x" },
    { text: "3× / minggu", value: "3x" },
    { text: "4× / minggu", value: "4x" }
  ];
  peruntukanOptions = [
    "Izin kerja/sekolah",
    "Klaim BPJS",
    "Klaim asuransi swasta",
    "Mutasi pegawai",
    "Perjalanan/transportasi",
    "Transfer perawatan antar-fasyankes",
    "Persyaratan administratif lain"
  ];
  aksesOptions = ["AV-Fistula", "AV-Graft", "Tunneled CDL", "Non-tunneled CDL", "Femoral (temporary)"];

  pernyataan: any = { fasyankes: "RSUD Panembahan Senopati Bantul", frasa_tambahan: null };
  riwayat: any = {
    frekuensi_per_minggu: "2x",
    tgl_mulai: null,
    durasi_jam: null,
    status_hd: "active",
    akses_vaskular: null,
    akses_lokasi: null
  };
  diagnosis: any = { icd: null, nama: null, etiologi: null };
  komorbid: any = { hbsag: null };
  preskripsi: any = { tipe_hd: null };
  peruntukan: any = { kategori: null, tingkat_detail: "ringkas", penerima: null };

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.TindakanHd, this.dataSuket.id)
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        pernyataan: this.pernyataan,
        riwayat: this.riwayat,
        diagnosis: this.diagnosis,
        komorbid: this.komorbid,
        preskripsi: this.preskripsi,
        peruntukan: this.peruntukan
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  mounted() {
    this.hydrate(this.dataSuket);
  }

  hydrate(d: any) {
    this.register_id = d?.register_id || this.register;
    this.pasien_rm = d?.pasien_rm || this.pasien.rm;
    this.unit_id = d?.unit_id || this.user.unit_id;
    this.surat_date = d?.surat_date || new Date();
    this.signee_user_id = d?.signee_user_id || this.user.id;
    this.creator_user_id = d?.creator_user_id || this.user.id;

    const c = d?.content;
    if (c) {
      this.pernyataan = { ...this.pernyataan, ...(c.pernyataan || {}) };
      this.riwayat = { ...this.riwayat, ...(c.riwayat || {}) };
      this.diagnosis = { ...this.diagnosis, ...(c.diagnosis || {}) };
      this.komorbid = { ...this.komorbid, ...(c.komorbid || {}) };
      this.preskripsi = { ...this.preskripsi, ...(c.preskripsi || {}) };
      this.peruntukan = { ...this.peruntukan, ...(c.peruntukan || {}) };
    }
  }

  @Watch("dataSuket")
  changeDataSuket(val: any) {
    this.hydrate(val);
  }

  save() {
    if (this.saving) return;
    if (!this.riwayat.frekuensi_per_minggu) {
      appModule.sendErrorAlert("Frekuensi HD per minggu wajib diisi");
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        if (this.canSign) {
          this.showSignatureModal();
        }
        appModule.NoticeDelay("Berhasil Simpan");
        this.closeInput();
        StoreSuketTindakanHd.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  remove() {
    if (!this.dataSuket) return;
    this.suketSvc.destroy(this.dataSuket.id).then(() => {
      appModule.NoticeDelay("Berhasil Hapus Surat Keterangan");
      StoreSuketTindakanHd.getSuketByRegister(this.register);
    });
  }
}
